import AceCodeEditorsContainer from "../../Componant/Editors/AceCodeEditors";

const AceCodeEditors = () => {
  return (
    <div className="page-body">
      <AceCodeEditorsContainer />
    </div>
  );
};

export default AceCodeEditors;
